function waitForElement(selector, timeout = 10000) {
  return new Promise((resolve, reject) => {
    const timeoutId = setTimeout(() => {
      reject(new Error(`Timed out waiting for element with selector "${selector}"`));
    }, timeout);

    const intervalId = setInterval(() => {
      const element = document.querySelector(selector);
      if (element) {
        clearInterval(intervalId);
        clearTimeout(timeoutId);
        resolve(element);
      }
    }, 100);
  });
}

const { pageType } = window.meta.page;

// This is the hook for the moin.ai chat widget. It fires when the chat widget is ready.
window.chatWidgetReady = function () {
  // Set new `z-index` for the chat widget so it doesn't overlap drawers and modals. The API
  // documents a `setWidgetzIndex(index)` method, but it doesn't work. So we have to set the
  // `z-index` manually.

  (async () => {
    const chatWidgetElement = await waitForElement('#moin-ai-container');

    chatWidgetElement.style.zIndex = 'calc(var(--z-index-modal) - 1)';
  })();

  if (pageType === 'product') {
    // Adjustments for the product page.
    // Here we want to move the chat widget above the sticky ATC, so it doesn't get overlapped.

    const stickyAddToCartButtonElement = document.querySelector('.quantity-addToCart-block-wrapper.sticky');

    if (stickyAddToCartButtonElement) {
      const stickyAddToCartButtonHeight = stickyAddToCartButtonElement.offsetHeight;
      window.moin.setPosition({ bottom: stickyAddToCartButtonHeight, right: 'auto', unit: 'px' });
    }
  }

  if (pageType === 'collection') {
    // Adjustments for the collection page.
    // Here we want to move the chat widget above the filters, so they don't get overlapped.

    const mobileFiltersElement = document.querySelector('.mobile-filters');

    if (mobileFiltersElement) {
      const mobileFiltersHeight = mobileFiltersElement.offsetHeight;
      window.moin.setPosition({ bottom: mobileFiltersHeight, right: 'auto', unit: 'px' });
    }
  }
};
